import { BaseFilterProps, Filter, FilterData } from "../_types";
import { FilterComponent } from "../base-filter";

export class VehicleBlockedFilter extends Filter<unknown, unknown> {
  readonly id: string = "blockedVehicles";
  readonly labelSingular = "common:BlockStatus";
  readonly labelPlural = "common:BlockStatus";
  readonly placeholder = "common:SelectBlockStatus";
  readonly searchPlaceholder = "common:SelectBlockStatus";
  readonly emptyText = "common:NoOptionsAvailable";

  constructor({ id }: { id?: string } = {}) {
    super();
    if (id) this.id = id;
  }

  getData(): FilterData {
    const options = [
      {
        id: "unblocked",
        name: "common:UnblockedVehicles",
      },
      {
        id: "blocked",
        name: "common:BlockedVehicles",
      },
    ];

    return {
      options,
      isLoading: false,
      error: null,
    };
  }

  render(props: BaseFilterProps) {
    return <FilterComponent filter={this} {...props} />;
  }
}
